import { render, staticRenderFns } from "./editPayroll.vue?vue&type=template&id=9b83d848&scoped=true&"
import script from "./editPayroll.vue?vue&type=script&lang=js&"
export * from "./editPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b83d848",
  null
  
)

export default component.exports